import consola from 'consola'
import { useLogger } from '#imports'

export const useGameLogger = () => {
    return useLogger().withTag('@spilnu/game')
}
